import React from 'react';
import type SearchConstituent from '@/types/api/SearchConstituent';

const getFirstNameLastInitial = (fullName: string) => {
  const [firstName, ...rest] = fullName.split(' ');
  const lastInitial = rest.length ? `${rest[rest.length - 1].charAt(0)}.` : '';
  return [firstName, lastInitial].join(' ').trim();
};

// TODO(jon): On hover this should do what the home feed does and show a small
// popover with the assignee's avatar and contact info.
function ConstituentAssignee({
  constituent,
}: {
  constituent: SearchConstituent;
}) {
  const { developers = [] } = constituent;
  const assignee = (developers.find(({ primary }) => primary) || developers[0])
    ?.displayName;

  return assignee ? <>{getFirstNameLastInitial(assignee)}</> : null;
}

export default ConstituentAssignee;
